import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from '../../App/Ducks/Table.duck';
import { newMercureMessage } from '../../App/Ducks/App.duck';
import { getUsers } from '../services/userService';

export const actionTypes = {
  RequestData: '[Users] AdminRequestUsers',
  FulfilledTable: '[Users] AdminFulfilledUsers',
  SearchTable: '[Users] Search',
  ChangePage: '[Users] change page',
  SetPageSize: '[Users] set page size',
  SortTable: '[Users] Sort',
  ApplyFilter: '[Users] Apply filter',
  RemoveFilter: '[Users] Remove filter',
  ResetFilters: '[Users] Reset filter',
};

const initialState = {
  ...tableInitialState,
  sortBy: { name: 'asc' },
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestTenantsSaga() {
    const currentState = yield select(state => state.UsersReducer);

    const response = yield getUsers(
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });

  yield takeEvery(newMercureMessage, function* execute(action) {
    if (typeof action.data['@type'] === 'string' && action.data['@type'] === 'User') {
      yield put(actions.requestData());
    }
  });
}
